/**
 * Camada única de tracking.
 * Empurra eventos para o dataLayer (GTM) e, quando presentes, para
 * gtag (GA4 / Google Ads), fbq (Meta Pixel) e _tfa (Taboola).
 * Nenhuma tag é injetada aqui: o container é colado no __root pelo time.
 */

export type NookEvent =
  | "view_method"
  | "view_unit"
  | "click_experimental"
  | "click_whatsapp"
  | "click_maps"
  | "click_waze"
  | "view_reviews"
  | "play_institutional_video"
  | "unit_pricing_view"
  | "unit_pricing_click"
  | "executive_hours_open"
  | "institutional_day_use_click";

type Payload = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    _tfa?: unknown[];
  }
}

export function track(event: NookEvent, data: Payload = {}) {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
    window.gtag?.("event", event, data);
    window.fbq?.("trackCustom", event, data);
    window._tfa?.push({ notify: "event", name: event, id: undefined });
  } catch {
    /* tracking nunca deve quebrar a página */
  }
}
